import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
// img
import TelegramGuideImg from '@assets/images/guide/telegram-guide-img.png'
// icon
// css
import {
  ContentWrap,
  Content,
} from '@styles/base.style'
import { TelegramSettingBtnWrap } from '@styles/button.style'
import DialogUtils from '@utils/dialog-utils'
import FloatingButtonImage from '@assets/images/banner/telegram-floating-button.png'

import Login from '@views/Login'

interface TelegramGuideProps {
  hasFloatingButton?: boolean
}

const TelegramGuide = ({ hasFloatingButton = false }: TelegramGuideProps) => {
  const { authStore } = useRootStore()

  let contentWarpStyle
  if (!isMobile) {
    contentWarpStyle = { overflow: 'auto' }
  }

  const onShowTelegramSetting = () => {
    if (!authStore.isSignedIn) {
      authStore.showLoginPopup(<Login/>)
      return
    }
    DialogUtils.showTelegramSetting()
  }

  return (
    <Fragment>
      <ContentWrap style={contentWarpStyle} className="telegram-guide-wrap">
        <Content>
          <img src={TelegramGuideImg} alt="텔레그램 연동 가이드 이미지" style={{ width: '100%' }}/>
        </Content>
      </ContentWrap>
      {hasFloatingButton && (
        <TelegramSettingBtnWrap className="telegram-setting-btn-wrap">
          <div className="telegram-setting-tooltip">
            <span className="telegram-setting-tooltip--text">텔레그램 연동 혜택 받자!</span>
          </div>
          <button type="button" onClick={onShowTelegramSetting} className="telegram-setting-btn">
            <img src={FloatingButtonImage} alt="알림 설정하기"/>
          </button>
        </TelegramSettingBtnWrap>
      )}
    </Fragment>
  )
}

export default observer(TelegramGuide)
